export const firebaseConfig = {
    apiKey: "AIzaSyB4_1H2O3ff9DyOEPSYIr6dJf97pZOyswo",
    authDomain: "recognaize-fc4a3.firebaseapp.com",
    projectId: "recognaize-fc4a3",
    storageBucket: "recognaize-fc4a3.appspot.com",
    messagingSenderId: "859324379193",
    appId: "1:859324379193:web:19e2541ea42ddd8e635de8",
    measurementId: "G-17PVEF6XVQ"
};